require('./head');
require('./menu');
require('./mobile-nav');
require('./fixed-position');



// WEBPACK FOOTER //
// ./js/main/module/head/index.js